import type { WidgetPreset } from "../types";
import { TimerPreview } from "./TimerFace";
import { INITIAL_TIMER } from "./timerState";
import { TimerWidget } from "./TimerWidget";

export const TIMER_DIGITAL: WidgetPreset = {
  id: "timer-digital",
  label: "Timer",
  meaning: "Count down a meeting or a break",
  defaultWidth: 264,
  defaultHeight: 352,
  component: TimerWidget,
  resizable: { minWidth: 132, minHeight: 176 },
  preview: TimerPreview,
  initialData: { ...INITIAL_TIMER },
};
